import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  numberIcon: {
    height: '24px',
    width: '24px',
    borderRadius: '50%',
    verticalAlign: 'bottom',
    backgroundColor: '#E3E3E3',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      color: '#FFFFFF',
      backgroundColor: '#000000'
    }
  }
});

export default useStyles;
